import { render, staticRenderFns } from "./country-details.vue?vue&type=template&id=3e43614c&scoped=true&lang=pug&"
import script from "./country-details.vue?vue&type=script&lang=js&"
export * from "./country-details.vue?vue&type=script&lang=js&"
import style0 from "./country-details.vue?vue&type=style&index=0&id=3e43614c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43614c",
  null
  
)

component.options.__file = "country-details.vue"
export default component.exports